import { useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { QrCode, Download } from "lucide-react";
import { toast } from "sonner";
import { shareImage } from "../../lib/shareImage";
import { Btn } from "./kit";
import { Modal } from "./Form";

/** Scannable invite link for team meetings. The access code is shown only when we still have it (right after sending). */
export const InviteQR = ({ link, email, teamName, role, code, testid = "invite-qr", compact = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const download = async () => {
    try {
      await shareImage(ref.current, { fileName: `invite-${(email ?? "qr").replace(/[^a-z0-9]+/gi, "-")}.png`, mode: "download" });
      toast.success("QR code downloaded");
    } catch {
      toast.error("Couldn't create the image. Please try again");
    }
  };
  return (
    <>
      {compact ? (
        <button data-testid={`${testid}-button`} onClick={() => setOpen(true)} className="rounded-full p-2 text-slate-400 hover:text-white" aria-label="Show QR code"><QrCode className="h-4 w-4" /></button>
      ) : (
        <Btn variant="ghost" data-testid={`${testid}-button`} onClick={() => setOpen(true)}><QrCode className="h-4 w-4" />Show QR code</Btn>
      )}
      <Modal open={open} onClose={() => setOpen(false)} testid={`${testid}-dialog`} title="Scan to join" description={`Invite for ${email}. They scan it with their phone camera, then enter the access code.`}>
        <div className="mt-3 flex justify-center">
          <div ref={ref} data-testid={`${testid}-card`} className="w-[300px] rounded-2xl bg-white p-6 text-center text-[#0A0E1A]">
            <p className="font-display text-lg font-black uppercase leading-tight">{teamName ?? "Your team"}</p>
            <p className="mb-4 font-mono-gd text-[10px] uppercase tracking-[0.25em] text-slate-600">Join as {role ?? "member"} on GAMEDAY</p>
            <QRCodeSVG value={link} size={240} level="M" marginSize={1} data-testid={`${testid}-svg`} className="mx-auto h-auto w-full" />
            {code ? (
              <p className="mt-4 font-mono-gd text-xs uppercase tracking-wider text-slate-600">Access code <span data-testid={`${testid}-code`} className="block font-display text-2xl font-black normal-case tracking-normal text-[#0A0E1A]">{code}</span></p>
            ) : (
              <p className="mt-4 text-xs text-slate-600">Ask your coach for the access code.</p>
            )}
            <p className="mt-3 break-all font-mono-gd text-[9px] text-slate-500">{link}</p>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Btn variant="ghost" data-testid={`${testid}-download`} onClick={download}><Download className="h-4 w-4" />Download for printing</Btn>
        </div>
      </Modal>
    </>
  );
};
